import contentCompiled from './content.hbs';
import contentBodyCompiled from './content.body.hbs';
import { Context } from './types';
import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';

interface ContentContext {
    announcement: {
        id: string | number;
    };
    widgetid: string | number;
}

export const contentTemplate: TypeSafeTemplateDelegate<Context<ContentContext>> = contentCompiled;

interface ContentBodyContext {
    calculatedCaptionTop: number;
    announcementId: string | number;
    calculatedImageLeft: number;
    calculatedImageWidth: number;
    calculatedImageHeight: number;
    image: string;
    title: string;
}

export const contentBodyTemplate: TypeSafeTemplateDelegate<ContentBodyContext> =
    contentBodyCompiled;
